export const GEOMFA_MENU_HEATMAP = [
	"Adjusted Yield (bu/ac)",
	"Yield",
	"Total Plant Health (AUC_DAP_NDRE)",
	"Total Plant Health (Satellite) (AUC_DAP_SNDRE)",
	"Early Vegetation (GAUC_DAP_NDVI)",
	"Early Vegetation (Satellite) (GAUC_DAP_SNDVI)",
	"Leaf Area (LAI)",
	"Leaf Area (LAI_M3M)",
	"Leaf Area (SLAI)",
];

export const GEOMFA_MENU_ZONE = ["Surface Texture Zones", "Historical Vegetation Zones", "Vegetation Stability Zones"];

export const GEOMFA_MENU_IMAGERY = ["LAI", "LAI_M3M", "RGB", "SNDVI"];
